import React, { type ReactNode, useCallback, useEffect } from 'react';
import { useUserAtom } from '../jotai/useUserAtom';
import { useMyInfo } from '../../../queries';

export const UserExperimentalGroupSetComponent: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const { data } = useMyInfo();
  const [init, setInit] = React.useState(false);
  const { setUserAtomExperimentalGroups } = useUserAtom();

  const checkExperimentalGroups = useCallback(async () => {
    if (!data) {
      return;
    }
    setUserAtomExperimentalGroups(data.experiment_groups);
    setInit(true);
  }, [data, setUserAtomExperimentalGroups]);

  useEffect(() => {
    if (!init) {
      checkExperimentalGroups();
    }
  }, [checkExperimentalGroups, init]);

  if (!init) {
    return null;
  }

  return children;
};
